const snakeToCamel = (str: string): string =>
  str.replace(/_([a-z])/g, g => g[1].toUpperCase());

/**
 * Converting snake_case keys to camelCase for flat objects
 * Should only be used temporarily during transition period
 * between Hermes to streamWS patterns
 */
export const convertKeysToCamelCase = (
  obj: Record<string, unknown>,
): Record<string, unknown> => {
  const newObj: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[snakeToCamel(key)] = obj[key];
    }
  }

  return newObj;
};
